import { render, staticRenderFns } from "./ProjectViewer__Slide.vue?vue&type=template&id=28253906&lang=pug&"
import script from "./ProjectViewer__Slide.vue?vue&type=script&lang=js&"
export * from "./ProjectViewer__Slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports